// src/hooks/useTodayScores.ts
import { useMemo } from "react";
import { useResonanceData } from "../components/organisms/ResonanceContext/ResonanceDataContext";

const isSameLocalDay = (iso: string) => {
  const d = new Date(iso);
  const now = new Date();
  return (
    d.getFullYear() === now.getFullYear() &&
    d.getMonth() === now.getMonth() &&
    d.getDate() === now.getDate()
  );
};

/**
 * Returns:
 * - hasScoreToday: Set<sequenceId>
 * - todayScores: Map<sequenceId, lastScoreValue>
 * - todayScoreObjects: Map<sequenceId, fullScoreObject>
 */
export const useTodayScores = () => {
  const { scores } = useResonanceData();

  return useMemo(() => {
    const hasScoreToday = new Set<number>();
    const todayScores = new Map<number, number>();
    const todayScoreObjects = new Map<number, any>();

    (scores ?? []).forEach((s) => {
      if (!isSameLocalDay(s.doneAt)) return;

      const seq = s.sequenceId;

      hasScoreToday.add(seq);

      // If multiple scores today → keep the latest
      const existing = todayScoreObjects.get(seq);
      if (!existing || new Date(s.doneAt) > new Date(existing.doneAt)) {
        todayScoreObjects.set(seq, s);
        todayScores.set(seq, s.score);
      }
    });

    return {
      hasScoreToday,
      todayScores,
      todayScoreObjects,
    };
  }, [scores]);
};
